import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  chartBackground: {
    padding: `${theme.spacing(10)}px ${theme.spacing(4)}px ${theme.spacing(3)}px 0`,
    width: '100%',
    position: 'relative'
  },
  chart: {
    padding: '0px !important',
    position: 'relative'
  },
  legend: {
    fontSize: 13,
    fontWeight: 'normal',
    color: '#000000',
    marginLeft: theme.spacing(4),
    position: 'absolute',
    bottom: theme.spacing(2),
    left: theme.spacing(2)
  },
  period: {
    top: '-60px',
    left: '16px',
    width: '120px',
    height: '40px',
    position: 'absolute'
  }
}))
